export const Colors = {
  main: '#1bb271',

  light_green: '#e6f6f0',

  gray_9a: '#9a9a9a',
  gray_d8: '#d8d8d8'
}